import { useRecoilState } from 'recoil';

import { Option, Series } from '../types';

import { storage } from '../modules';
import { checkIsValid, indicatorState } from "../store";

export default function useIndicator() {
  const [indicator, setIndicator] = useRecoilState(indicatorState)

  const handleIndicatorState = (
    series: Series,
    period: number,
    option: Option,
    value: string | number | boolean
  ) => {
    setIndicator((prev) => ({
      ...prev,
      [series]: [
        ...prev[series].map((indicator) =>
          indicator.period === period
            ? {
              ...indicator,
              [option]: value,
            }
            : indicator
        ),
      ],
    }))
  }

  const handleVsmaDisable = (nextState?: boolean) => {
    setIndicator((prev) => ({
      ...prev,
      disableVsma: nextState === undefined ? !prev.disableVsma : nextState,
    }))
  }

  const handleSmaDisable = (nextState?: boolean) => {
    setIndicator((prev) => ({
      ...prev,
      disableSma: nextState === undefined ? !prev.disableSma : nextState,
    }))
  }

  const handleStorageSave = () => {
    storage.set('sma', JSON.stringify(indicator.sma))
    storage.set('vsma', JSON.stringify(indicator.vsma))
    storage.set('disable-smas', indicator.disableSma ? 'true' : '')
    storage.set('disable-vsma', indicator.disableVsma ? 'true' : '')
  }

  const updateRecentIndicator = () => {
    const sma = checkIsValid(storage.get('sma'))
    const vsma = checkIsValid(storage.get('vsma'))
    const disableSma = Boolean(storage.get('disable-smas'))
    const disableVsma = Boolean(storage.get('disable-vsma'))

    if (sma && vsma) {
      setIndicator({
        sma,
        vsma,
        disableSma,
        disableVsma,
      })
    }
  }

  return {
    indicator,
    handleIndicatorState,
    handleVsmaDisable,
    handleSmaDisable,
    handleStorageSave,
    updateRecentIndicator,
  }
}
